import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from, Observable } from 'rxjs'
import {
  InviteUserTest,
  inviteUserTestActions,
  InviteUserTestActions
} from 'src/tests-components/invite-user/invite-user-test.actions'
import { InviteUserTestState } from './invite-user-test.reducer'
import { notification } from 'antd'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { genericError } from 'src/utils/notifications.utils'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

type Actions = InviteUserTestActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<InviteUserTestState> {}

const invitationCall = (dsService: DSService) => (p: InviteUserTest): Observable<InviteUserTestActions> =>
  from(
    dsService
      .inviteUserToTest({
        email: p.email,
        firstName: p.firstName,
        lastName: p.lastName,
        testId: p.testId,
        dueDate: p.dueDate.toISOString(),
        token: p.invitorToken
      })
      .map(invitedOpt =>
        pipe(
          invitedOpt,
          O.fold(
            () => {
              genericError()
              return inviteUserTestActions.InviteUserTestFailure({ [stopFetch]: p[startFetch] })
            },
            _invited => {
              notification.success({
                description: "L'invitation a bien été envoyée",
                message: 'Invitation envoyée'
              })
              return inviteUserTestActions.InviteUserTestSuccess({ [stopFetch]: p[startFetch] })
            }
          )
        )
      )
  )

export const invitationEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(inviteUserTestActions.is.InviteUserTest),
    mergeMap(invitationCall(deps.dsService))
  )

export const inviteUserTestEpics = combineEpics(invitationEpic)



// WEBPACK FOOTER //
// ./src/tests-components/invite-user/invite-user-test.epics.ts